
import * as yup from 'yup';

export const newPreagendamientoSchema = yup.object({
  distancia: yup.string().optional(),
  coordenadas: yup.string().required('Campo Requerido'),
  //flota: yup.string().required('Campo Requerido'),
  como_se_entero: yup.string().required('Campo Requerido'),
  herramienta_utilizada: yup.string().required('Campo Requerido'),
  tipo_vivienda: yup.string().required('Campo Requerido'),
  numero_pisos: yup.string().required('Campo Requerido'),
  numero_dispositivos: yup.string().required('Campo Requerido')
});

export const newMotivoPreagendamientoSchema = yup.object({
  id_preagendamiento: yup.string().required('Campo Obligatorio'),
  motivo_rechazo: yup.string().required('Campo Obligatorio'),
});

export const solicitudTecnicoFormSchema = yup.object({
  flota_adicional: yup.string().required('Campo Obligatorio'),
});